import { Card } from "@yleisradio/areena-types";
import { StateCreator } from "zustand";

import {
  AbTestAnalyticsContext,
  RecommendationAnalyticsContext
} from "../../types/snowplow";
import { PlayerStoreProperties } from "../store";
import { StoreMiddlewares } from "../storeTypes";

type SnowplowQuality = {
  bitrate: number;
  newQuality: string;
  framerPerSecond: number;
  automatic: boolean;
};

type SnowplowEvents = {
  onBufferStart: () => void;
  onBufferEnd: () => void;
  onDestroy: () => void;
  onFinish: () => void;
  onFullscreenChange: (fullscreen: boolean) => void;
  onPause: () => void;
  onPipChange: (pip: boolean) => void;
  onPlay: () => void;
  onPlaybackRateChange: (newRate: number) => void;
  onQualityChange: (quality: SnowplowQuality) => void;
  onRecommendationClick: (
    recommendation: Card,
    recommendationsCount: number,
    index: number,
    viewUuid: string
  ) => void;
  onRecommendationPlayClick: (
    recommendation: Card,
    recommendationsCount: number,
    index: number,
    viewUuid: string
  ) => void;
  onRecommendationView: (
    recommendation: Card,
    recommendationsCount: number,
    index: number,
    viewUuid: string,
    recommendationContext?: RecommendationAnalyticsContext,
    abTestContext?: AbTestAnalyticsContext
  ) => void;
  onSeekStart: () => void;
  onSeekEnd: () => void;
  onTimeUpdate: (currentTime: number) => void;
  onVolumeChange: (newVolume: number) => void;
};

export type AnalyticsSliceState = {
  snowplowEvents: SnowplowEvents | undefined;
};

type AnalyticsSliceActions = {
  setSnowplowEvents: (analyticsEvents: SnowplowEvents) => void;
};

export type AnalyticsSlice = AnalyticsSliceState & AnalyticsSliceActions;

export const ANALYTICS_SLICE_DEFAULTS: AnalyticsSliceState = {
  snowplowEvents: undefined
};

export const analyticsSlice: StateCreator<
  PlayerStoreProperties,
  StoreMiddlewares,
  [],
  AnalyticsSlice
> = set => ({
  ...ANALYTICS_SLICE_DEFAULTS,
  setSnowplowEvents: snowplowEvents =>
    set({ snowplowEvents }, false, "setSnowplowEvents")
});
